<template>
  <div v-if="anyAlertsExist" id="future-or-past-alerts" class="mb-0">
    <div
      v-if="isFutureYear"
      class="alert bg-dark text-center text-white list-unstyled mb-0 p-2"
    >
      <strong>IMPORTANT:</strong> This parcel exists in future years only.
    </div>

    <ul
      v-if="isPastYear"
      class="alert bg-dark text-center text-white list-unstyled mb-0 p-2"
    >
      <li>
        <strong>Information:</strong> Pay Year selected is a History Year. The
        information displayed on the screen is not Current Tax Information.
      </li>
    </ul>
  </div>
</template>
<style></style>
<script>
export default {
  computed: {
    anyAlertsExist() {
      return this.isPastYear || this.isFutureYear;
    },
    isFutureYear() {
      return this.item.PAYYEAR > parseInt(this.currentPayYear);
    },
    isPastYear() {
      return this.item.PAYYEAR < parseInt(this.currentPayYear);
    },
  },
  props: {
    currentPayYear: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
